import { Box, Typography, List, ListItem, ListItemText, Alert } from '@mui/material';

const ConfirmStep = ({ selectedFolder, mode, folderMappings }) => (
  <Box>
    <Typography variant="h6" gutterBottom>
      Confirmar Importación
    </Typography>

    <List>
      <ListItem>
        <ListItemText primary="Carpeta OneDrive" secondary={selectedFolder?.path} />
      </ListItem>
      <ListItem>
        <ListItemText
          primary="Modo"
          secondary={mode === 'new' ? 'Crear Nuevos Expedientes' : 'Agregar a Expedientes Existentes'}
        />
      </ListItem>
      {mode === 'new' && (
        <ListItem>
          <ListItemText
            primary="Expedientes a crear"
            secondary={`${folderMappings.length} expedientes`}
          />
        </ListItem>
      )}
    </List>

    <Alert severity="info" sx={{ mt: 2 }}>
      El proceso se ejecutará en el servidor y continuará aunque cierres esta ventana.
      Podrás ver el progreso en cualquier momento.
    </Alert>
  </Box>
);

export default ConfirmStep;
